<script setup lang="ts">
const props = defineProps<{
  text: string
  disabled?: boolean
  type: 'main' | 'sub'
  onClick?: () => void
}>()
</script>

<template>
  <button
    class="base-large-button body-md"
    :class="props.type"
    :disabled="props.disabled"
    @click="props.onClick"
  >
    {{ props.text }}
  </button>
</template>

<style scoped>
.base-large-button {
  width: 100%;
  height: 56px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  text-align: center;
  letter-spacing: 0;
  text-align: center;
}

.base-large-button:not(:disabled):hover {
  text-decoration: underline;
  cursor: pointer;
}

.base-large-button.main {
  background-color: var(--tint-500);
  color: var(--white);
}

.base-large-button.sub {
  background-color: var(--tint-100);
  color: var(--tint-500);
}

.base-large-button:disabled.main {
  background-color: var(--gray-800);
  color: var(--gray-600);
}

.base-large-button:disabled.sub {
  background-color: var(--tint-100);
  color: var(--tint-300);
}
</style>
